import React from 'react'
import { lit } from 'src/utils'

type Tab = {
    name: string
    field: string
}

export interface TabsProps {
    /**
     * The classname -- this is mostly used to hook GA event tracking
     */
    className?: string

    /**
     * An array of objects with field, name, and href keys used to populate the tabs.
     */
    tabs: Tab[]

    /**
     * The field value of the currently selected tab.
     */
    activeTab?: string

    /**
     * The function to be called when a tab is selected.
     */
    onSelectTab: (tabField: string) => void

    /**
     * An array of field values for tabs that should not appear on mobile displays.
     */
    largeOnlyTabs?: string[]

    /**
     * Applies additional bottom-margin spacing
     */
    hasSpacing?: boolean
}

export function Tabs({
    className = 'js_Tabs',
    tabs,
    activeTab,
    onSelectTab,
    largeOnlyTabs,
    hasSpacing = true,
}: TabsProps) {
    // note: base CSS classes are from https://tailwindui.com/
    const spacingClass = hasSpacing
        ? 'block mb-8 sm:mb-3'
        : 'relative mx-auto mb-3.5'
    return (
        <div
            className={`${className} ${spacingClass} overflow-x-auto overflow-y-hidden`}
        >
            <div>
                <nav className="-mb-px flex space-x-4" aria-label="Tabs">
                    {tabs.map((tab) => (
                        <button
                            type="button"
                            key={tab.name}
                            className={lit`
            ${
                tab.field === activeTab
                    ? 'border-b-[3px] border-brand-black font-bold'
                    : 'border-transparent text-neutral-700'
            } ${
                                largeOnlyTabs?.includes(tab.field) &&
                                'hidden sm:block'
                            } whitespace-nowrap pb-1 text-xs
            `}
                            aria-current={
                                tab.field === activeTab ? 'page' : undefined
                            }
                            onClick={() => onSelectTab(tab.field)}
                        >
                            {tab.name}
                        </button>
                    ))}
                </nav>
            </div>
        </div>
    )
}
